import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Jira Standard PaymentDetailsPopup (Jira in trial, not invoiceable, can add payment).
 */
export function isEligibleForStandardPaymentDetailsPopup(
	context: EditionAwarenessContextType,
): boolean {
	const { product, edition, isInTrial, invoiceableStatus, canAddPaymentDetails, isInCollection } =
		context;

	if (fg('ea_audience_and_timing_refactor')) {
		return Boolean(
			!isInCollection &&
			isEditionOneOf(edition, ['standard']) &&
			product === 'jira' &&
			isInTrial &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails,
		);
	}

	return Boolean(
		isEditionOneOf(edition, ['standard']) &&
		product === 'jira' &&
		isInTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails,
	);
}
